export default __webpack_public_path__ + "static/media/Slide_SaleKit2024-04.c36dc221.png";